/* VH Virtual Events (sections/vh-virtual.liquid).
   PART 1 is COPIED VERBATIM from sections/Events-Section.liquid L1108-1351 (its inline <script>): add to cart (/cart/add.js by
   data-product-id, then /cart), join-time buttons, registration deadlines, expired-event removal, the sign-up fetch to /contact,
   and the modal helpers. Not one line changed, so the network calls and DOM hooks are exactly the live page's.
   PART 2 is new presentation only (the countdown card + weekly calendar). */

/* Visitor-facing strings come from the theme locale: sections/vh-virtual.liquid prints them as JSON (#vh-virtual-i18n).
   Every use below keeps the original English as the fallback, so nothing changes if the block is missing. */
var vhVirtualI18n = (function () {
  try { return JSON.parse(document.getElementById('vh-virtual-i18n').textContent) || {}; } catch (e) { return {}; }
})();

/* ===== PART 1: verbatim from sections/Events-Section.liquid L1108-1351 ===== */
  (function() {
    // Add to cart functionality
    function initAddToCart() {
      const addToCartButtons = document.querySelectorAll('[data-add-to-cart]');
      
      addToCartButtons.forEach(button => {
        button.addEventListener('click', function(e) {
          e.preventDefault();
          
          const productId = this.getAttribute('data-product-id');
          if (!productId) return;
          
          const originalText = this.textContent;
          this.textContent = vhVirtualI18n.adding || 'Adding...';
          this.disabled = true;
          
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: productId,
              quantity: 1
            })
          })
          .then(response => response.json())
          .then(data => {
            window.location.href = '/cart';
          })
          .catch(error => {
            console.error('Error:', error);
            this.textContent = vhVirtualI18n.errorRetry || 'Error - Try Again';
            this.disabled = false;
            setTimeout(() => {
              this.textContent = originalText;
            }, 2000);
          });
        });
      });
    }

    // Event button updates
    function updateEventButtons() {
      const buttons = document.querySelectorAll('[data-join-time]');
      const now = new Date().getTime();

      buttons.forEach(button => {
        const joinTime = parseInt(button.getAttribute('data-join-time')) * 1000;
        const buttonUrl = button.getAttribute('data-button-url');
        const activeText = button.getAttribute('data-active-text');
        const productId = button.getAttribute('data-product-id');
        const timeUntil = joinTime - now;
        
        if (timeUntil <= 0 && button.classList.contains('disabled')) {
          button.classList.remove('disabled');
          button.classList.add('event-button-live');
          
          if (productId) {
            const newButton = document.createElement('button');
            newButton.className = 'event-button event-button-live';
            newButton.textContent = activeText;
            newButton.setAttribute('data-product-id', productId);
            newButton.setAttribute('data-add-to-cart', '');
            button.parentNode.replaceChild(newButton, button);
            initAddToCart();
          } else {
            const newButton = document.createElement('a');
            newButton.href = buttonUrl;
            newButton.target = '_blank';
            newButton.className = 'event-button event-button-live';
            newButton.textContent = activeText;
            button.parentNode.replaceChild(newButton, button);
          }
        } else if (timeUntil > 0 && timeUntil <= 600000) {
          const countdownElement = button.querySelector('.button-countdown');
          if (countdownElement) {
            const minutes = Math.floor(timeUntil / 60000);
            const seconds = Math.floor((timeUntil % 60000) / 1000);
            const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
            countdownElement.innerHTML = (vhVirtualI18n.opensIn || 'Opens in <strong>{time}</strong>').replace('{time}', () => formattedTime);
          }
        }
      });
    }

    function checkRegistrationDeadlines() {
      const cards = document.querySelectorAll('[data-registration-deadline]');
      const now = new Date().getTime();

      cards.forEach(card => {
        const deadline = parseInt(card.getAttribute('data-registration-deadline')) * 1000;
        const closedText = card.getAttribute('data-closed-text');
        const button = card.querySelector('.event-button:not(.registration-closed)');
        
        if (deadline < now && button && !button.classList.contains('registration-closed')) {
          const closedButton = document.createElement('div');
          closedButton.className = 'event-button registration-closed';
          closedButton.textContent = closedText;
          button.parentNode.replaceChild(closedButton, button);
        }
      });
    }

    function removeExpiredEvents() {
      const cards = document.querySelectorAll('[data-event-end]');
      const now = new Date().getTime();

      cards.forEach(card => {
        const endTime = parseInt(card.getAttribute('data-event-end')) * 1000;
        const eventType = card.getAttribute('data-event-type');
        const hideTime = eventType === 'inperson' ? endTime + 60000 : endTime;
        
        if (hideTime < now) {
          card.style.transition = 'opacity 0.5s ease-out';
          card.style.opacity = '0';
          setTimeout(() => card.remove(), 500);
        }
      });
    }

    // Email signup form handling
    const form = document.getElementById('event-updates-form');
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        
        const formData = new FormData(form);
        const successMessage = document.getElementById('form-success');
        const errorMessage = document.getElementById('form-error');
        
        successMessage.classList.remove('show');
        errorMessage.classList.remove('show');
        
        fetch('/contact', {
          method: 'POST',
          body: formData,
          headers: {
            'Accept': 'application/json'
          }
        })
        .then(response => {
          if (response.ok) {
            successMessage.classList.add('show');
            form.reset();
          } else {
            errorMessage.classList.add('show');
          }
        })
        .catch(error => {
          errorMessage.classList.add('show');
        });
      });
    }

    // Modal functionality
    function initModals() {
      const modalTriggers = document.querySelectorAll('[data-modal-id]');
      const modalClosers = document.querySelectorAll('[data-close-modal]');
      
      modalTriggers.forEach(trigger => {
        trigger.addEventListener('click', function(e) {
          e.preventDefault();
          const modalId = this.getAttribute('data-modal-id');
          const modal = document.getElementById(modalId);
          if (modal) {
            modal.classList.add('active');
            document.body.classList.add('modal-open');
          }
        });
      });
      
      modalClosers.forEach(closer => {
        closer.addEventListener('click', function() {
          const modalId = this.getAttribute('data-close-modal');
          const modal = document.getElementById(modalId);
          if (modal) {
            modal.classList.remove('active');
            document.body.classList.remove('modal-open');
          }
        });
      });
      
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          const activeModal = document.querySelector('.event-modal.active');
          if (activeModal) {
            activeModal.classList.remove('active');
            document.body.classList.remove('modal-open');
          }
        }
      });
    }

    // Initialize
    initAddToCart();
    initModals();
    updateEventButtons();
    checkRegistrationDeadlines();
    removeExpiredEvents();

    setInterval(() => {
      updateEventButtons();
      checkRegistrationDeadlines();
      removeExpiredEvents();
    }, 10000);

    function startFastChecking() {
      const buttons = document.querySelectorAll('[data-join-time]');
      const now = new Date().getTime();
      let nearEvent = false;

      buttons.forEach(button => {
        const joinTime = parseInt(button.getAttribute('data-join-time')) * 1000;
        const timeUntil = joinTime - now;
        
        if (timeUntil > 0 && timeUntil <= 600000) {
          nearEvent = true;
        }
      });

      if (nearEvent) {
        const fastInterval = setInterval(() => {
          updateEventButtons();
          checkRegistrationDeadlines();
          removeExpiredEvents();
          
          const stillNear = Array.from(document.querySelectorAll('[data-join-time]')).some(button => {
            if (!button.classList.contains('disabled')) return false;
            const joinTime = parseInt(button.getAttribute('data-join-time')) * 1000;
            const timeUntil = joinTime - new Date().getTime();
            return timeUntil > 0 && timeUntil <= 600000;
          });
          
          if (!stillNear) {
            clearInterval(fastInterval);
          }
        }, 1000);
      }
    }

    startFastChecking();
    setInterval(startFastChecking, 60000);
  })();

/* ---------- Presentation only (new, approved in the preview): the "Up next" card and the "This week" calendar ----------
   Reads the event cards rendered by the section (data-vh-*: recurring days + recurring_time, or join/end timestamps).
   No network calls. Recurring times are read in the section's time zone setting (data-tz, default New York). */
(function () {
  var root = document.getElementById('vh-virtual');
  if (!root || root.getAttribute('data-vh-on')) return;
  root.setAttribute('data-vh-on', '1');
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var one = function (s) { return root.querySelector(s); };
  var all = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;'}[c]; }); };
  var TZ = root.getAttribute('data-tz') || 'America/New_York';
  var TZ2 = root.hasAttribute('data-tz2') ? root.getAttribute('data-tz2') : 'America/Mexico_City';
  var I = vhVirtualI18n, TZN = I.tz || {};
  var LBL = {'America/New_York': [TZN.eastern || 'Eastern', 'ET'], 'America/Chicago': [TZN.central || 'Central', 'CT'], 'America/Denver': [TZN.mountain || 'Mountain', 'MT'], 'America/Los_Angeles': [TZN.pacific || 'Pacific', 'PT'], 'America/Mexico_City': [TZN.mexicoCity || 'Mexico City', TZN.mexicoCityTime || 'Mexico City time'], 'America/Hermosillo': [TZN.hermosillo || 'Hermosillo', TZN.hermosilloTime || 'Hermosillo time']};
  var tzName = (LBL[TZ] || [TZ, TZ])[0], tzShort = (LBL[TZ] || [TZ, TZ])[1];
  var DAYN = I.days && I.days.length === 7 ? I.days : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var VIEW_TZ = 'UTC'; try { VIEW_TZ = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'; } catch (e) {}
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };

  /* "9:00 AM - 11:00 AM EST" -> [[9,0],[11,0]]; one time only -> one hour */
  function parseTime(t) {
    var re = /(\d{1,2})(?::(\d{2}))?\s*([AaPp])\.?\s*[Mm]?\.?/g, m, out = [];
    while ((m = re.exec(t || '')) && out.length < 2) { var h = +m[1] % 12; if (/p/i.test(m[3])) h += 12; out.push([h, +(m[2] || 0)]); }
    if (!out.length) return null;
    if (out.length === 1) out.push([Math.min(23, out[0][0] + 1), out[0][1]]);
    return out;
  }
  function partsIn(tz, d) {
    var p = {}; new Intl.DateTimeFormat('en-US', {timeZone: tz, hourCycle: 'h23', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', weekday: 'short'}).formatToParts(d || new Date()).forEach(function (x) { p[x.type] = x.value; });
    return {y: +p.year, m: +p.month, d: +p.day, h: +p.hour % 24, mi: +p.minute, s: +p.second, wd: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(p.weekday)};
  }
  function zoned(y, m, d, h, mi) {   /* the instant when it is y-m-d h:mi in TZ */
    var guess = Date.UTC(y, m - 1, d, h, mi), p = partsIn(TZ, new Date(guess));
    return new Date(guess - (Date.UTC(p.y, p.m - 1, p.d, p.h, p.mi) - guess));
  }
  var EV = all('[data-vh-ev]').map(function (c) {
    var days = c.getAttribute('data-vh-days'), o = {card: c, title: c.getAttribute('data-vh-title') || '', url: c.getAttribute('data-vh-url') || '', plat: c.getAttribute('data-vh-platform') || ''};
    if (days != null) { o.days = days.split(',').filter(function (x) { return x !== ''; }).map(Number); o.t = parseTime(c.getAttribute('data-vh-time')); if (!o.t || !o.days.length) return null; }
    else if (c.getAttribute('data-vh-start')) { o.s = new Date(+c.getAttribute('data-vh-start') * 1000); o.e = new Date(+c.getAttribute('data-vh-stop') * 1000); if (c.getAttribute('data-vh-online') !== '1') return null; }
    else return null;
    return o;
  }).filter(Boolean);
  if (!EV.length) return;

  function sessions(now) {   /* every session from Monday of this week (in TZ) for 14 days, plus one-time events */
    var p = partsIn(TZ, now), back = (p.wd + 6) % 7, base = Date.UTC(p.y, p.m - 1, p.d) - back * 864e5, out = [];
    for (var i = 0; i < 14; i++) {
      var dd = new Date(base + i * 864e5), y = dd.getUTCFullYear(), m = dd.getUTCMonth() + 1, d = dd.getUTCDate(), wd = dd.getUTCDay();
      EV.forEach(function (ev) { if (ev.days && ev.days.indexOf(wd) > -1) out.push({ev: ev, wd: wd, i: i, d: d, s: zoned(y, m, d, ev.t[0][0], ev.t[0][1]), e: zoned(y, m, d, ev.t[1][0], ev.t[1][1])}); });
    }
    EV.forEach(function (ev) { if (ev.s && ev.e > now) out.push({ev: ev, wd: partsIn(TZ, ev.s).wd, i: -1, s: ev.s, e: ev.e}); });
    return out.sort(function (a, b) { return a.s - b.s; });
  }
  var fmt = function (d, tz) { return new Intl.DateTimeFormat('en-US', {timeZone: tz, hour: 'numeric', minute: '2-digit'}).format(d); };
  var range = function (a, b, tz) { var A = fmt(a, tz), B = fmt(b, tz); return (A.slice(-2) === B.slice(-2) ? A.slice(0, -3) : A) + ' – ' + B; };

  var con = one('[data-vh-console]');
  function tick() {
    if (!con) return;
    var now = new Date(), list = sessions(now), live = null, next = null;
    list.forEach(function (x) { if (!live && x.s <= now && now < x.e) live = x; if (!next && x.s > now) next = x; });
    next = live || next;
    root.classList.toggle('is-live', !!live);
    if (!next) { con.hidden = true; return; }
    con.hidden = false;
    one('[data-vh-status]').textContent = live ? (I.liveNow || 'Live now') : (I.upNext || 'Up next');
    one('[data-vh-plat]').textContent = next.ev.plat;
    one('[data-vh-ctitle]').textContent = next.ev.title;
    one('[data-vh-cwhen]').textContent = DAYN[next.wd] + ' · ' + range(next.s, next.e, TZ) + ' ' + tzShort;
    var diff = Math.max(0, (live ? next.e : next.s) - now) / 1000;
    one('[data-vh-d]').textContent = pad(Math.floor(diff / 86400)); one('[data-vh-h]').textContent = pad(Math.floor(diff % 86400 / 3600));
    one('[data-vh-m]').textContent = pad(Math.floor(diff % 3600 / 60)); one('[data-vh-s]').textContent = pad(Math.floor(diff % 60));
    one('[data-vh-clock]').setAttribute('aria-label', live ? (I.timeLeft || 'Time left in this session') : (I.timeUntil || 'Time until the session starts'));
    var rows = [[tzName, range(next.s, next.e, TZ)]];
    /* optional second zone (section setting "Also show times in"; Mexico City on MX, none on Global) */
    if (TZ2 && TZ2 !== TZ) rows.push([(LBL[TZ2] || [TZ2])[0], range(next.s, next.e, TZ2)]);
    if (VIEW_TZ !== TZ && VIEW_TZ !== TZ2) rows.push([I.yourTime || 'Your time', range(next.s, next.e, VIEW_TZ)]);
    var h = rows.map(function (r) { return '<dt>' + r[0] + '</dt><dd>' + r[1] + '</dd>'; }).join('');
    var loc = one('[data-vh-local]'); if (loc.innerHTML !== h) loc.innerHTML = h;
    var cta = next.ev.url ? '<a class="vh-btn ' + (live ? 'vh-virtual-btn-live' : 'vh-btn-cream') + '" href="' + esc(next.ev.url) + '" target="_blank" rel="noopener">' + (live ? (I.joinNow || 'Join Event Now') : (next.ev.plat ? (I.joinOn || 'Join on {plat}').replace('{plat}', function () { return esc(next.ev.plat); }) : (I.join || 'Join'))) + ' <span class="ar" aria-hidden="true">→</span></a>' : '';
    var box = one('[data-vh-cctas]'); if (box.getAttribute('data-k') !== cta) { box.innerHTML = cta; box.setAttribute('data-k', cta); box.hidden = !cta; }
  }

  var wk = one('[data-vh-week]'), wkSec = one('[data-vh-week-sec]');
  function renderWeek() {
    if (!wk) return;
    var now = new Date(), p = partsIn(TZ, now), list = sessions(now).filter(function (x) { return x.i >= 0 && x.i < 7; });
    var lo = 24, hi = 0;
    EV.forEach(function (ev) { if (ev.t) { lo = Math.min(lo, ev.t[0][0] + ev.t[0][1] / 60); hi = Math.max(hi, ev.t[1][0] + ev.t[1][1] / 60); } });
    if (hi <= lo) { wkSec.hidden = true; return; }
    var H0 = Math.max(0, Math.floor(lo) - 3), H1 = Math.min(24, Math.ceil(hi) + 1), hours = [];
    /* about six hour labels whatever the span: hourly for a short day (MX 6a-12p), every 2-3 h for a long one
       (Global 6a-9p); the track's grid lines follow the same step (--bands) */
    var STEP = Math.max(1, Math.ceil((H1 - H0) / 6));
    H1 = Math.min(24, H0 + Math.ceil((H1 - H0) / STEP) * STEP);
    for (var hh = H0; hh <= H1; hh += STEP) hours.push(hh);
    var BANDS = Math.round((H1 - H0) / STEP);
    var pct = function (h, mi) { return ((h + mi / 60 - H0) / (H1 - H0)) * 100; };
    var lab = function (h) { return (h % 12 || 12) + (h < 12 || h === 24 ? 'a' : 'p'); };
    var html = '<div class="vh-virtual-wk-axis" aria-hidden="true"><span></span><ol>' + hours.map(function (h) { return '<li style="top:' + pct(h, 0) + '%">' + lab(h) + '</li>'; }).join('') + '</ol></div>';
    var back = (p.wd + 6) % 7, base = Date.UTC(p.y, p.m - 1, p.d) - back * 864e5;
    for (var i = 0; i < 7; i++) {
      var dd = new Date(base + i * 864e5), wd = dd.getUTCDay(), today = i === back;
      var mine = list.filter(function (x) { return x.i === i; });
      var slots = mine.map(function (x) {
        var cls = now >= x.e ? 'done' : now >= x.s ? 'live' : '';
        var top = pct(x.ev.t[0][0], x.ev.t[0][1]), ht = pct(x.ev.t[1][0], x.ev.t[1][1]) - top;
        /* sessions under ~1.5 h are too short for two lines: one line, minimum height (css .is-short) */
        if (ht < 10) cls += ' is-short';
        return '<div class="vh-virtual-slot ' + cls + '" style="top:' + top + '%;height:' + ht + '%"><b>' + esc(x.ev.title) + '</b><span>' + fmt(x.s, TZ) + '</span></div>';
      }).join('');
      var nowLine = today && p.h + p.mi / 60 >= H0 && p.h + p.mi / 60 < H1 ? '<i class="vh-virtual-now" style="top:' + pct(p.h, p.mi) + '%" aria-hidden="true"></i>' : '';
      var label = DAYN[wd] + ' ' + dd.getUTCDate() + ': ' + (mine.map(function (x) { return x.ev.title + ' ' + fmt(x.s, TZ); }).join(', ') || (I.noSessions || 'no sessions'));
      html += '<div class="vh-virtual-day' + (today ? ' today' : '') + '" role="group" aria-label="' + esc(label) + '"><div class="vh-virtual-day-h"><b>' + DAYN[wd].slice(0, 3) + '</b><span>' +
        new Intl.DateTimeFormat(I.locale || 'en-US', {month: 'short', timeZone: 'UTC'}).format(dd) + ' ' + dd.getUTCDate() + '</span></div><div class="vh-virtual-track" style="--bands:' + BANDS + '">' + slots + nowLine + '</div></div>';
    }
    wk.innerHTML = html; wkSec.hidden = false;
  }

  renderWeek(); tick();
  setInterval(tick, 1000); setInterval(renderWeek, 60000);

  if (window.VHK && VHK.withGsap) VHK.withGsap(function (ok) {
    if (!ok) return;
    var gsap = window.gsap, ScrollTrigger = window.ScrollTrigger;
    gsap.from(all('.vh-virtual-hero-copy, .vh-virtual-stage'), {autoAlpha: 0, y: 40, duration: 1.1, stagger: .14, ease: 'power3.out', delay: .1});
    if (con) gsap.from(con, {autoAlpha: 0, y: 30, duration: 1, ease: 'power3.out', delay: .55});
    var img = one('.vh-virtual-stage > img');
    if (img) gsap.fromTo(img, {scale: 1.08}, {scale: 1, ease: 'none', scrollTrigger: {trigger: img.parentNode, start: 'top bottom', end: 'bottom top', scrub: true}});
    /* the week's sessions grow into their time slots once, together */
    if (wk) ScrollTrigger.create({trigger: wk, start: 'top 80%', once: true, onEnter: function () { gsap.from(all('.vh-virtual-slot', wk), {scaleY: 0, duration: .9, ease: 'power3.out'}); }});
    all('.vh-rv').forEach(function (el) { gsap.fromTo(el, {autoAlpha: 0, y: 48}, {autoAlpha: 1, y: 0, duration: 1.15, ease: 'power3.out', scrollTrigger: {trigger: el, start: 'top 88%', once: true}}); });
    (window.VHK && VHK.refresh ? VHK.refresh() : ScrollTrigger.refresh());
  });
  if (RM) root.classList.add('vh-virtual-rm');
})();
